module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "portfolio-item",
    style: (_vm.bgstyle),
    attrs: {
      "data-ar": "0.68125"
    }
  }, [_h('a', {
    staticClass: "scrim",
    attrs: {
      "href": _vm.url,
      "target": "_blank"
    }
  }, [_h('b', [_vm._s(_vm.title)]), " ", _h('p', ["\n      " + _vm._s(_vm.desc) + "\n    "])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63f0d10c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PortfolioItem.vue
// module id = 52
// module chunks = 1